import { AuthProvider } from './auth';
import { SearchProvider } from './search';
import { ShareListProvider } from './shareList';

const AppProvider = ({ children }: any) => {
    return (
        <AuthProvider>
            <ShareListProvider>
                <SearchProvider>
                    {children}
                </SearchProvider>
            </ShareListProvider>
        </AuthProvider>
    )
};

export default AppProvider;
